import './App.scss';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import MainLayout from 'components/templates/MainLayout';
import routes from 'helpers/routes';
import { store } from 'store';

const App: React.FC = () => (
  <Routes>
    <Route element={<MainLayout />}>
      {routes.map((route) => (
        <Route
          key={route.id}
          path={route.path}
          element={route.element}
        />
      ))}
    </Route>
  </Routes>
);

const AppRoot: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
            <ToastContainer
              className="toast-custom"
              toastClassName="toast-custom_body"
              closeButton={() => null}
              position="top-right"
              autoClose={2000}
              hideProgressBar
              icon={false}
            />
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default AppRoot;
